import { PagedMessageResponse } from "app/api/types/PagedMessageResponse";
import globalMU from "globalMU";
import React from "react";

const estiloEncomenda = require("./encomenda.module.scss").default;
const estiloTabela = require('../../../../estilos/tabelas.module.scss').default

export type Encomendas = {
    NumeroPedido: number
    FilialVenda: string
    FilialRetirada: string
    FilialTransferencia: string
    NomeCliente: string
    Quantidade: number
    DataPedido: string
    DataPrevistaEntrega: string
    NomeVendedor: string
    SituacaoVenda: string
    DescricaoSituacaoVenda: string
    NumeroPedidoCompra: number
}

export type PesquisaSubConsultasEncomenda = {
    CodigoProduto: string
    Filial: string
}

export type EncomendaProdutoProps = {
    dados: Encomendas[];
};

export const EncomendaProduto = (props: EncomendaProdutoProps) => {

    const tableHead = <div className="_table-row">
        <div className={`_table-cell ${estiloEncomenda.tableCellHeader}`}>
            Pedido
        </div>
        <div className={`_table-cell ${estiloEncomenda.tableCellHeader}`}>
            Filial
        </div>
        <div className={`_table-cell ${estiloEncomenda.tableCellHeader}`}>
            Filial Retirada
        </div>
        <div className={`_table-cell ${estiloEncomenda.tableCellHeader}`}>
            Filial Transf.
        </div>
        <div className={`_table-cell ${estiloEncomenda.tableCellHeader}`}>
            Cliente
        </div>
        <div className={`_table-cell ${estiloEncomenda.tableCellHeader}`}>
            Quantidade
        </div>
        <div className={`_table-cell ${estiloEncomenda.tableCellHeader}`}>
            Data Pedido
        </div>
        <div className={`_table-cell ${estiloEncomenda.tableCellHeader}`}>
            Entrega
        </div>
        <div className={`_table-cell ${estiloEncomenda.tableCellHeader}`}>
            Vendedor
        </div>
        <div className={`_table-cell ${estiloEncomenda.tableCellHeader}`}>
            Situação
        </div>
        {<div className={`_table-cell ${estiloEncomenda.tableCellHeader}`}>
            Ped Compra
        </div>}
    </div>

    const tableBody = props?.dados?.filter(c => c.NumeroPedido > 0)?.map((dado) => (
        <div key={dado.NumeroPedido} className={`_table-row ${estiloEncomenda.linha}`}>
            <div
                className={`_table-cell _text-center ${estiloEncomenda.tableCellBody}`}
            >
                {dado?.NumeroPedido}
            </div>
            <div
                className={`_table-cell  ${estiloEncomenda.tableCellBody}`}
            >
                {dado?.FilialVenda}
            </div>
            <div
                className={`_table-cell  ${estiloEncomenda.tableCellBody}`}
            >
                {dado?.FilialRetirada}
            </div>
            <div
                className={`_table-cell  ${estiloEncomenda.tableCellBody}`}
            >
                {dado?.FilialTransferencia}
            </div>
            <div
                className={`_table-cell  ${estiloEncomenda.tableCellBody}`}
            >
                {dado?.NomeCliente}
            </div>

            <div
                className={`_table-cell  ${estiloEncomenda.tableCellBody}`}
            >
                {globalMU.formatarValorNumerico(dado?.Quantidade, 3, false)}
            </div>
            <div
                className={`_table-cell  ${estiloEncomenda.tableCellBody}`}
            >
                {globalMU.formatDate(dado?.DataPedido)}
            </div>
            <div
                className={`_table-cell  ${estiloEncomenda.tableCellBody}`}
            >
                {globalMU.formatDate(dado?.DataPrevistaEntrega)}
            </div>
            <div
                className={`_table-cell  ${estiloEncomenda.tableCellBody}`}
            >
                {dado?.NomeVendedor}
            </div>
            <div
                className={`_table-cell  ${estiloEncomenda.tableCellBody}`}
            >
                {dado?.DescricaoSituacaoVenda}
            </div>
            {<div
                className={`_table-cell  ${estiloEncomenda.tableCellBody}`}
            >
                {dado?.NumeroPedidoCompra}
            </div>}

        </div>
    ))

    return (
        <>
            <div className={estiloTabela.containerRolavel}>
                <div className={`_table _w-full _border-collapse ${estiloEncomenda.table}`}>
                    <div className="_table-header-group">
                        {tableHead}
                    </div>
                    <div className="_table-row-group">
                        {tableBody}
                    </div>
                </div>
            </div>
        </>
    )
} 